import { TypographyVariants } from './Typography.types';

export const TYPOGRAPHY_COMPONENT_MAP: Record<TypographyVariants, string> = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  value: 'h5',
  h5: 'h5',
  h6: 'h6',
  label: 'label',
  paragraph: 'p',
};

export const VARIANT_CLASS_NAME_MAP: Record<TypographyVariants, string> = {
  h1: 'text-h1 font-700',
  h2: 'text-h2 font-700',
  h3: 'text-h3 font-700',
  h4: 'text-h4 font-500',
  h5: 'text-h5 font-500',
  h6: 'text-h6 font-500',
  label: 'text-label font-500',
  paragraph: 'text-label font-500',
  value: 'text-h6 font-500',
};
